export default __webpack_public_path__ + "static/media/cc.6883eaf6.png";